/** 玩家微信支付窗口，同时写入 orders.paymentDeadlineAt、wechat_payments.expiresAt 与微信 time_expire */
export const paymentWindowMs = 5 * 60 * 1000
/** 微信 time_expire 距当前至少 1 分钟，否则下单会被拒 */
export const wechatMinExpireMs = 60 * 1000

export const gameTicketName = '比赛券'
export const defaultTicketValueAmount = 8800

export function paymentDeadlineAt(from = new Date()): Date {
  return new Date(from.getTime() + paymentWindowMs)
}

export function paymentWindowError(
  deadline: Date,
  now = new Date(),
): string | null {
  if (deadline.getTime() <= now.getTime()) return '支付已超时，请重新下单'
  if (deadline.getTime() - now.getTime() < wechatMinExpireMs)
    return '支付剩余时间不足，请重新下单'
  return null
}

export interface OrderAmountInput {
  subtotalAmount: number
  adjustmentAmount: number
}

export interface OrderAmounts extends OrderAmountInput {
  amount: number
}

export interface VoucherAdjustmentInput {
  itemAmount: number
  valueAmount: number
}

function assertCents(value: number, field: string): void {
  if (!Number.isSafeInteger(value) || value < 0)
    throw new RangeError(`${field}必须是非负整数分`)
}

export function calculateOrderAmounts(input: OrderAmountInput): OrderAmounts {
  assertCents(input.subtotalAmount, '订单原价')
  assertCents(input.adjustmentAmount, '订单优惠')
  if (input.adjustmentAmount > input.subtotalAmount)
    throw new RangeError('订单优惠不能超过订单原价')
  return {
    ...input,
    amount: input.subtotalAmount - input.adjustmentAmount,
  }
}

export function calculateVoucherAdjustment(
  input: VoucherAdjustmentInput,
): number {
  assertCents(input.itemAmount, '商品金额')
  assertCents(input.valueAmount, '票券面额')
  if (input.valueAmount === 0) throw new RangeError('票券面额必须大于 0 分')
  return Math.min(input.itemAmount, input.valueAmount)
}

export function selectHighestPayableLine<T extends { payableAmount: number }>(
  lines: T[],
): T | null {
  if (lines.length === 0) return null
  return lines.reduce((best, line) =>
    line.payableAmount > best.payableAmount ? line : best,
  )
}

export function ticketValueForGender(input: {
  ticketValueAmount: number
  ticketValueAmountFemale: number | null
  gender: 'male' | 'female' | 'unknown'
}): number {
  if (input.gender === 'female' && input.ticketValueAmountFemale !== null)
    return input.ticketValueAmountFemale
  return input.ticketValueAmount
}
